import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { Switch, Tooltip } from '@wanjianshi/admin-ui';
import { useAdminThemeMode } from '@/app/theme-mode';

export function AdminThemeSwitch({ className = '' }: { className?: string }) {
  const { mode, setMode } = useAdminThemeMode();
  const targetModeLabel = mode === 'dark' ? '白天模式' : '黑夜模式';

  return (
    <Tooltip title={`切换至${targetModeLabel}`}>
      <span className={`admin-theme-switch-wrap ${className}`.trim()}>
        <Switch
          className="admin-theme-switch"
          checked={mode === 'dark'}
          checkedChildren={<MoonOutlined />}
          unCheckedChildren={<SunOutlined />}
          aria-label={`切换至${targetModeLabel}`}
          onChange={checked => setMode(checked ? 'dark' : 'light')}
        />
      </span>
    </Tooltip>
  );
}
